import { CountryRiskIndex, CountryRiskView } from '@grid-ui/common';
import { ItemInformationListingItemDatatype } from '../item-information-listing';
import { CommodityRiskView } from '../risk-view';

/**
 * Typeguard to determine whether the specified data for an Item Information Listing
 * supports unique identification by "id" property.
 *
 * @param data An Item Information Listing item.
 */
export function isIdDatatype(data: ItemInformationListingItemDatatype): data is CountryRiskView | CountryRiskIndex | CommodityRiskView {
  return (data as any).id !== undefined;
}
